import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _classCallCheck from '@babel/runtime/helpers/classCallCheck';
import _createClass from '@babel/runtime/helpers/createClass';
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function (r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for (var r = 1; r < arguments.length; r++) {
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
import { heartbeatVideo } from '../api/transcode';
import BoInfo from '../utils/browser';
import utils from '../core/utils';
import scene from './scene-config';
export var log = process.env.NODE_ENV !== 'NO_LOG' ? console.error.bind(console, 'EVENT-INFO') : function () {
};
export var info = process.env.NODE_ENV !== 'NO_LOG' ? console.info.bind(console, 'EVENT-INFO') : function () {
};
var heartbeatVideoWithLog = function heartbeatVideoWithLog(params) {
    info(params.event, params);
};
function isArrayEqual(a, b) {
    return a.sort().join('') === b.sort().join('');
}
var systemParamList = [
    'sceneId',
    'event',
    'eventType',
    'guId',
    'sequence',
    'version',
    'sourceUuid',
    'sourceType',
    'sourceUrl',
    'sourceTime',
    'uUrl',
    'osVer',
    'deviceModel',
    'clientTimestamp'
];
var progressParamList = [
    'durAfterLoaded',
    'durTotalPlayed',
    'durAfterFirstPlayed',
    'eventPos'
];
var businessParamList = [
    'subjectId',
    'courseId',
    'lessonId',
    'topicId',
    'moduleId',
    'moduleType',
    'chapterId',
    'tagCode',
    'questionsId',
    'engineId',
    'learnType',
    'learnCount',
    'engineSequence',
    'uId'
];
var userParamList = [
    'schoolId',
    'accountId',
    'userId',
    'teacherId'
];
var commonParamList = [].concat(systemParamList, progressParamList, businessParamList, userParamList);
var events = {
    VIDEO_INIT: [
        'volume',
        'resolution',
        'rate'
    ],
    VIDEO_CLOSE: [],
    VIDEO_PLAY: [
        'cdnSeedCount',
        'cdnSeedOkDur',
        'bufferTime'
    ],
    VIDEO_END: [],
    VIDEO_PAUSE: ['eventType'],
    VIDEO_RESUME: ['pauseTime'],
    VIDEO_REPLAY: ['replayCount'],
    VIDEO_FORWARD: [
        'startDragPos',
        'endDragPos'
    ],
    VIDEO_BACKWARD: [
        'startDragPos',
        'endDragPos'
    ],
    VIDEO_SCREENSHOT: ['screenshotState'],
    VIDEO_VOLUME: [
        'startVolume',
        'endVolume'
    ],
    VIDEO_RESOLUTION: [
        'startResolution',
        'endResolution',
        'cdnSeedCount',
        'cdnSeedOkDur',
        'bufferTime',
        'sourceUrl'
    ],
    VIDEO_RATE: [
        'startRate',
        'endRate'
    ],
    VIDEO_OPENFULL: [],
    VIDEO_ENDFULL: [],
    VIDEO_OPENPICTURE: [],
    VIDEO_ENDPICTURE: [],
    VIDEO_BLOCK: [],
    VIDEO_ENDBLOCK: ['bufferTime'],
    VIDEO_OFFTURN: [],
    VIDEO_ONTURN: [],
    VIDEO_SUCCESSFUL: [
        'cdnSeedCount',
        'cdnSeedOkDur',
        'bufferTime'
    ],
    VIDEO_FAILED: [
        'cdnSeedCount',
        'cdnSeedOkDur',
        'bufferTime',
        'errorSourceUrl',
        'nextSourceUrl',
        'sourceUrl'
    ],
    VIDEO_ERROR: [
        'cdnSeedCount',
        'cdnSeedOkDur',
        'bufferTime',
        'sourceUrl'
    ],
    VIDEO_HEARBEAT: [
        'currentEvent',
        'currentEventTime'
    ]
};
var notCurrentEvent = [
    'VIDEO_FORWARD',
    'VIDEO_BACKWARD',
    'VIDEO_SCREENSHOT',
    'VIDEO_VOLUME',
    'VIDEO_RESOLUTION',
    'VIDEO_RATE',
    'VIDEO_OPENFULL',
    'VIDEO_ENDFULL',
    'VIDEO_OPENPICTURE',
    'VIDEO_ENDPICTURE',
    'VIDEO_BLOCK',
    'VIDEO_OFFTURN',
    'VIDEO_ONTURN',
    'VIDEO_HEARBEAT',
    'VIDEO_ENDBLOCK'
];
var autoEvent = [
    'VIDEO_INIT',
    'VIDEO_BLOCK',
    'VIDEO_END',
    'VIDEO_BLOCK',
    'VIDEO_ENDBLOCK',
    'VIDEO_SUCCESSFUL',
    'VIDEO_FAILED',
    'VIDEO_HEARBEAT'
];
var EventEmitter = function () {
    function EventEmitter(player) {
        _classCallCheck(this, EventEmitter);
        this._sequence = 1;
        this.events = {};
        this.commonParam = {};
        this.player = player;
        this.currentEventName = '';
        this.currentEventStart = '';
        this.timer = null;
        this.durTotalPlayed = 0;
        var host = window.location.host;
        if (host.includes('.test')) {
            var index = host.indexOf('.test');
            host = host.slice(0, index) + host.slice(index + 5);
        }
        info(host);
        this.host = host;
        this.initPlayerParams();
        this.initEvents();
        this.startTimer();
    }
    return _createClass(EventEmitter, [
        {
            key: 'toUpperCase',
            value: function toUpperCase(name) {
                return name.replace(/_(\w)/g, function (all, letter) {
                    return letter.toUpperCase();
                });
            }
        },
        {
            key: 'sequence',
            get: function get() {
                return this._sequence;
            },
            set: function set(newVal) {
                this._sequence = newVal;
            }
        },
        {
            key: 'startTimer',
            value: function startTimer() {
                var _this = this;
                var inValidEvent = ['VIDEO_BLOCK'];
                this.timer = setInterval(function () {
                    if (!_this.player.video.paused && !inValidEvent.includes(_this.currentEventName)) {
                        _this.durTotalPlayed += 0.25;
                    }
                }, 250);
            }
        },
        {
            key: 'endTimer',
            value: function endTimer() {
                clearInterval(this.timer);
                this.timer = null;
            }
        },
        {
            key: 'initPlayerParams',
            value: function initPlayerParams() {
                var _this2 = this;
                this.commonParam = _objectSpread({
                    version: this.player.constructor.version,
                    sequence: this.sequence,
                    sourceType: 0,
                    sourceUrl: this.player.options.video.url,
                    sourceTime: 0,
                    guId: utils.getUuid(),
                    uUrl: encodeURIComponent(window.location.href) || 'failure',
                    osVer: ''.concat(BoInfo.os, ' ').concat(BoInfo.osVersion) || 'failure',
                    deviceModel: BoInfo.browser,
                    sceneId: scene[this.host]
                }, this.player.options.collection);
                Object.keys(this.player.options.userInfo).forEach(function (key) {
                    var upperKey = _this2.toUpperCase(key);
                    if (commonParamList.includes(upperKey)) {
                        _this2.commonParam[upperKey] = _this2.player.options.userInfo[key];
                    }
                });
                [].concat(businessParamList, userParamList).forEach(function (key) {
                    if (!(key in _this2.commonParam)) {
                        info(''.concat(key, ' 值未传\uFF0C默认值为 0'));
                        _this2.commonParam[key] = '0';
                    }
                });
            }
        },
        {
            key: 'initEvents',
            value: function initEvents() {
                var _this3 = this;
                Object.keys(events).forEach(function (event) {
                    return _this3.on(event);
                });
            }
        },
        {
            key: 'on',
            value: function on(eventName) {
                var fn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : heartbeatVideoWithLog;
                this.events[eventName] = this.events[eventName] || [];
                this.events[eventName].push(fn);
            }
        },
        {
            key: 'emit',
            value: function emit(eventName) {
                var _this4 = this;
                var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                if (!scene[this.host]) {
                    info(''.concat(this.host, '未配置'));
                    return;
                }
                var restParam = {};
                if (!notCurrentEvent.includes(eventName)) {
                    this.currentEventName = eventName;
                    this.currentEventStart = Date.now();
                }
                data = _objectSpread({}, data);
                var cbs = this.events[eventName] || [];
                var requiredParams = events[eventName];
                var offeredParams = Object.keys(data);
                if (!cbs.length) {
                    log(eventName + '未注册');
                    return;
                }
                if (!isArrayEqual(requiredParams, offeredParams)) {
                    log(''.concat(eventName, '事件需要提供参数').concat(JSON.stringify(requiredParams), '\uFF0C已提供参数').concat(JSON.stringify(offeredParams)));
                }
                var now = Date.now();
                cbs.forEach(function (cb) {
                    _this4.merge(_this4.commonParam, data);
                    var eventType;
                    if (data.eventType) {
                        eventType = data.eventType;
                    } else if (eventName === 'VIDEO_PLAY' && _this4.player.options.autoplay) {
                        eventType = 'AT';
                    } else {
                        eventType = autoEvent.includes(eventName) ? 'AT' : 'MT';
                    }
                    _this4.clearData(data);
                    if (eventName !== 'VIDEO_HEARBEAT') {
                        _this4.sequence++;
                    }
                    var params = _objectSpread(_objectSpread(_objectSpread({}, _this4.commonParam), {}, {
                        sequence: _this4.sequence,
                        event: eventName,
                        clientTimestamp: now,
                        durTotalPlayed: _this4.durTotalPlayed,
                        durAfterLoaded: _this4.toSecond(now - (_this4.player.loadedTime || now)),
                        durAfterFirstPlayed: _this4.toSecond(now - (_this4.player.startPlayTime || now)),
                        eventPos: _this4.player.video.currentTime
                    }, restParam), {}, {
                        eventType: eventType,
                        eventData: _objectSpread({}, _this4.stringify(data))
                    });
                    commonParamList.every(function (key) {
                        if (!Object.keys(params).includes(key)) {
                            info('公共参数 '.concat(key, ' 缺失\uFF0C请通过 userInfo 传入'));
                            return false;
                        } else {
                            return true;
                        }
                    });
                    cb.call(null, params);
                });
            }
        },
        {
            key: 'toSecond',
            value: function toSecond(ms) {
                return ((ms || 0) / 1000).toFixed(2);
            }
        },
        {
            key: 'stringify',
            value: function stringify(data) {
                if (!data) {
                    return {};
                }
                return Object.keys(data).reduce(function (acc, curr) {
                    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, curr, typeof data[curr] === 'string' ? data[curr] : JSON.stringify(data[curr])));
                }, {});
            }
        },
        {
            key: 'clearData',
            value: function clearData(data) {
                delete data.eventType;
                Object.keys(data).forEach(function (key) {
                    if (data[key] === undefined || data[key] === '') {
                        data[key] = 0;
                    }
                });
            }
        },
        {
            key: 'merge',
            value: function merge(s, t) {
                Object.keys(s).forEach(function (key) {
                    if (t[key]) {
                        s[key] = t[key];
                    }
                });
            }
        },
        {
            key: 'destroy',
            value: function destroy() {
                var _this5 = this;
                Object.keys(this.events).forEach(function (key) {
                    _this5.events[key] = [];
                });
                this.endTimer();
            }
        }
    ]);
}();
export {
    EventEmitter as default
};